module.exports = __webpack_public_path__ + "static/media/Cats eyes 08_ENGELSKA-mixdown.e23682f7.mp3";